'use client';

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { WORKSPACE_CONTENT_HEIGHT } from '@/lib/constants/layout';
interface PageLoaderProps {
  className?: string;
  loaderClassName?: string;
  /**
   * Use workspace height (calc(100vh - 24px)) for pages inside workspace layout.
   * This is preferred over passing WORKSPACE_LOADER_HEIGHT as className.
   */
  useWorkspaceHeight?: boolean;
}

/**
 * Pre-configured height class for workspace pages with padding.
 * @deprecated Use `useWorkspaceHeight` prop instead for better reliability.
 */
export const WORKSPACE_LOADER_HEIGHT = 'h-[calc(100vh-24px)]';

/**
 * A centered loader component for page/component-level loading states.
 *
 * @example
 * // Full screen (for pages outside layouts)
 * <PageLoader className="h-screen" />
 *
 * // For pages inside workspace layout with p-3 padding
 * <PageLoader useWorkspaceHeight />
 *
 * // For pages with no padding (feedback, review, etc.)
 * <PageLoader className="min-h-screen" />
 */
export function PageLoader({
  className,
  loaderClassName,
  useWorkspaceHeight
}: PageLoaderProps) {
  return <div className={cn('flex items-center justify-center w-full', className)} style={useWorkspaceHeight ? {
    height: WORKSPACE_CONTENT_HEIGHT
  } : undefined} data-sentry-component="PageLoader" data-sentry-source-file="PageLoader.tsx">
      <Loader2 className={cn('h-8 w-8 animate-spin text-primary', loaderClassName)} data-sentry-element="Loader2" data-sentry-source-file="PageLoader.tsx" />
    </div>;
}